import 'twin.macro';
import { useTranslation } from 'next-i18next';

import { useAuth } from '@restworld/feature-authentication';
import { TabProp, Tabs } from '@restworld/ui-ds';

import { AccountSettingsTab } from './account-settings-tab';
import { UserNotificationTab } from './user-notification-tab';
import SaveResearchTab from './save-research-tab';

export const UserSettingsTabs = () => {
  const { t } = useTranslation('user-settings');
  const { user } = useAuth();
  const hoverMessage = (
    <span>
      {`${t('update_profile_use_this_feature')}`}
      &#128521;
    </span>
  );
  const newTabs: TabProp[] = [
    {
      label: t('page_tabs_account'),
      content: <AccountSettingsTab />,
    },
    {
      label: t('page_tabs_notifications'),
      content: <UserNotificationTab />,
      ...(user?.type === 'lead' ? { isActive: false } : {}),
      ...(user?.type === 'lead' ? { hoverMessage } : {}),
    },
    {
      label: t('page_tabs_research'),
      content: <SaveResearchTab />,
    },
  ];
  return (
    <div tw="flex flex-col">
      <Tabs tabs={newTabs} />
    </div>
  );
};
